import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyAccountingDto, UpsertAccountingRequest } from '../../models/api/companyAccountingDto';
import { CompanyAccountingContext } from '../../models/api/companyAccountingContext';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanyAccountingService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanyAccountingDto, CompanyAccountingContext>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyAccountingDto, CompanyAccountingContext>>(
      `${this.apiUrl}/${companyId}/accounting`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertAccountingRequest): Observable<CompanyAccountingDto> {
    return this.http.put<CompanyAccountingDto>(`${this.apiUrl}/${companyId}/accounting`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/accounting`, { params });
  }
}
